import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

export const AssetContext = createContext();
export const useAssets = () => useContext(AssetContext);

export default function AssetProvider({ children }) {
  const [assets, setAssets] = useState([]);
  const runSearch = (
    keyword = "",
    type = "",
    priceFrom = "",
    priceTo = "",
    commercialUse = ""
  ) => {
    const code = "ryc3Ec94HeGlzslQ/Rttq2paRT5RLAWgQqjbAQTU7EG70NowPlfzfA==";
    const appId = "testClient";
    const appPassword = "test";
    let url = `https://meta-assets-functions.azurewebsites.net/api/GetPublicAssets?code=${code}&appId=${appId}&appPassword=${appPassword}&keyword=${keyword}&type=${type}&priceFrom=${priceFrom}&priceTo=${priceTo}&commercialUse=${commercialUse}`;
    //console.log(url);

    fetch(url)
      .then((response) => response.json())
      .then((response) => setAssets(response["assets"]))
      .catch(console.error);
  };

  return (
    <AssetContext.Provider value={{ assets, setAssets, runSearch }}>
      {children}
    </AssetContext.Provider>
  );
}

AssetProvider.propTypes = {
  children: PropTypes.any,
};
